import api from 'api';
import React from 'react';
import EmailTemplate from '../EmailTemplates';

const RCU = () => {
  return <EmailTemplate apiRequest={api.administration.settings.getRCUTemplates} type="RCU" />;
};

export default RCU;
